import React from 'react';
import { BookOpenIcon, GraduationCapIcon, PresentationIcon, SchoolIcon, SparklesIcon } from 'lucide-react';
import { Accent, SectionHeading } from './SectionHeading';
import { audience } from '../../data/content';
const icons = [PresentationIcon, SchoolIcon, SparklesIcon, GraduationCapIcon, BookOpenIcon];
export function AudienceSection() {
  return <section aria-labelledby="audience-heading" className="bg-brand-paper px-5 py-16 lg:px-8 lg:py-24" data-id="element-30" data-mp="1tbmwijptyu5k">
      <div className="mx-auto max-w-6xl" data-id="element-31" data-mp="284otkac673rr">
        <SectionHeading id="audience-heading" eyebrow="Who It's For" title={<>
              Built for Beauty Educators <Accent data-id="element-33" data-mp="2h17ep0e5tnds">Like You.</Accent>
            </>} data-id="element-32" data-mp="238hvf3q0mwkd" />

        <ul className="mt-12 grid grid-cols-2 gap-4 lg:grid-cols-5" role="list" data-id="element-34" data-mp="2cy1f2bljyuga">
          {audience.map((role, index) => {
          const Icon = icons[index];
          return <li key={role} className={`flex flex-col items-center rounded-[20px] bg-brand-ivory px-4 py-7 text-center ${index === audience.length - 1 ? 'col-span-2 lg:col-span-1' : ''}`} data-id="element-35" data-mp="2lziqvhrxg9z6" data-mpi={index}>
                <span className="flex h-11 w-11 items-center justify-center rounded-full bg-brand-lavender/60" data-id="element-36" data-mp="2298osakojj32">
                  <Icon className="h-5 w-5 text-brand-violet" strokeWidth={1.5} aria-hidden="true" data-id="element-37" data-mp="26cespbkbky6d" />
                </span>
                <span className="mt-3 font-display text-[1.25rem] font-bold leading-tight text-brand-charcoal sm:text-[1.35rem]" data-id="element-38" data-mp="2b9x2t5a2pjfy">
                  {role}
                </span>
              </li>;
        })}
        </ul>

        <p className="mx-auto mt-12 max-w-2xl text-center text-[15px] leading-relaxed text-brand-charcoal/75 sm:text-[16px]" data-id="element-39" data-mp="2l2m4j8ftniy3">
          Whether you teach inside an academy, run your own training business or educate future beauty
          professionals,{' '}
          <strong className="font-semibold text-brand-charcoal" data-id="element-40" data-mp="2z0sp5mvrfmft">
            this system was designed to make your preparation easier and your classes more structured.
          </strong>
        </p>
      </div>
    </section>;
}